<template>
    <div class="boxes">
        <div class="box">
            <div class="box-heading border-bottom">
                <h5>社区获得的私服奖励</h5>
            </div>
        </div>
        <div class="threads-items mb-2">
            <ul class="list-group list-group-flush">
                <li
                    class="list-group-item d-md-flex d-block align-items-center justify-content-between cursor-pointer"
                >
                    <div class="d-flex align-items-center w-20">
                        <div class="text-blue">
                            私服账户
                        </div>
                    </div>
                    <div class="d-flex align-items-center w-40">
                        <div class="text-gray">
                            奖励描述
                        </div>
                    </div>
                    <div class="d-flex align-items-center w-20">
                        <div class="text-gray">
                            操作IP
                        </div>
                    </div>
                    <div class="d-flex align-items-center w-20">
                        <div class="text-gray">
                            获得日期
                        </div>
                    </div>
                </li>

                <li
                    class="list-group-item d-md-flex d-block align-items-center justify-content-between cursor-pointer"
                    v-for="item in lists.data"
                    :key="item.id"
                >
                    <div class="d-flex align-items-center w-20">
                        <div class="text-blue">
                            {{ item.asktao_account }}
                            <small v-if="item.server_name">（服务端：{{item.server_name}}）</small>
                        </div>
                    </div>
                    <div class="d-flex align-items-center w-40">
                        <div class="text-gray">
                            {{ item.content }}
                        </div>
                    </div>
                    <div class="d-flex align-items-center w-20">
                        <div class="text-gray">
                            {{ item.created_ip }}
                        </div>
                    </div>
                    <div class="d-flex align-items-center w-20">
                        <div class="text-gray">
                            {{ formatDate(item.created_time) }}
                        </div>
                    </div>
                </li>
            </ul>
            <paginator :meta="lists" @change="handlePageChanged"></paginator>
        </div>
    </div>
</template>

<script>
    import {
        TimeTransformationDate
    } from '@/utils/CommonUtil.js';
    import Paginator from '$components/paginator';
    export default {
        name: 'sign',
        components: {
            Paginator
        },
        data() {
            return {
                user_info: {},
                lists: {}
            }
        },
        created() {
            this.user_info = this.$user().user_info;
            
            this.getRewards(1);
        },
        methods: {
            handlePageChanged (page) {
                this.getRewards(page)
            },
            // 获取奖励记录
            getRewards(page = 1){
                this.$http
                    .get(`asktao/getRewards?page=${page}`)
                    .then((res) => {
                        this.lists = res.data;
                    });
            },
            handleChange(page) {
                this.$emit('page-changed', page)
            },
            formatDate(time){
                return TimeTransformationDate(time, true, true, true, true, true);
            }
        }
    }
</script>
